import { WritingAlert } from "./contents/underlines/writingAlertsSlice";
import { useIgnoredPhraseRules } from "./storage/hooks";

export default function useIsAlertIgnored(
  editorElement?: Element
): (alert: WritingAlert) => boolean {
  const { has: isIgnored } = useIgnoredPhraseRules();
  return (alert) => {
    if (!alert || !editorElement) {
      return false;
    }
    const { phrase } = alert;
    if (!phrase) {
      return false;
    }
    return isIgnored({
      phrase,
      rule: alert.feedback.ruleClassId,
    });
    // return isIgnored({ phrase });
  };
}
